import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Appointmentss from './components/Appointmentss';

const appointmentss = (props,{ t }) => (
  <Container>
    <Appointmentss {...props} />
  </Container>
);

appointmentss.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(appointmentss);
